import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  private latestErrorTimestamp$: BehaviorSubject<string> = new BehaviorSubject('');

  constructor() {}

  setTimestamp(timestamp: string): void {
    this.latestErrorTimestamp$.next(timestamp);
  }

  getTimestamp(): Observable<string> {
    return this.latestErrorTimestamp$.pipe(take(1));
  }
}
